import { styled } from '@linaria/react';
import { Group } from '@mantine/core';
import { baseWhite, inkLight, secondaryBase } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { H2 } from '../../ui-library/typography/typography';
import { useStrategyTabs } from './strategy.hooks';
import { StrategyTab } from './strategy.type';

export function StrategyHeader() {
  return (
    <HeaderWrapper>
      <TitleSection>
        <Icon name="track_changes" color={secondaryBase} size={36} />
        <H2>Strategy</H2>
      </TitleSection>
    </HeaderWrapper>
  );
}

export function StrategyTabsList({ active }: { active: StrategyTab }) {
  const tabs = useStrategyTabs();
  return (
    <Group gap="xs">
      {tabs
        .filter((tab) => tab.show)
        .map((tab) => {
          const isActive = tab.value === active;
          return (
            <Button
              data-bf={`strategy-tab-${tab.value}`}
              size="xs"
              radius="xl"
              key={tab.value}
              onClick={tab.onClick}
              variant={isActive ? 'secondary' : 'outline'}
              leftSection={
                <Icon name={tab.icon} size={14} color={isActive ? baseWhite : inkLight} style={{ cursor: 'pointer' }} />
              }
            >
              {tab.label}
            </Button>
          );
        })}
    </Group>
  );
}

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
